import { useEffect, useState, useCallback } from "react";
import { getAreaList } from "../../API/Lists/area";
import { getCountry } from "../../API/Lists/country";
import { CardJob } from "../../Components/CardJob/CardJob";
import { SearchIcon } from "../../Icons/Icons";
import { getCandidateInfo } from "../../API/Candidates/Cadidate";

import Select from "react-select";
import makeAnimated from "react-select/animated";

import Loading from "../../Components/Loading/Loading";
import JobServices from "../../API/Jobs/ServiceJobs";
import CandidatesApplyService from "../../API/Candidates/CandidatesApplyService";
import PaginationMydna from "../../Components/Pagination/Pagination";

import "./jobs.sass";
import { jobsTranslate } from "../../i18n/translatedMessages";
import { FormattedMessage } from "react-intl";

const LIMIT = 12;
const animatedComponents = makeAnimated();

const Jobs = () => {
	const { id } = JSON.parse(localStorage.getItem("user"));
	const [candidate, setCandidate] = useState(null);
	const [loading, setLoading] = useState(false);
	const [loadingJobs, setLoadingJobs] = useState(false);
	const [candidateJobs, setCandidateJobs] = useState([]);
	const [listJobs, setListJobs] = useState([]);
	const [page, setPage] = useState(1);
	const [totalData, setTotalData] = useState(0);
	const [interestAreas, setInterestAreas] = useState([1]);
	const [area, setAreas] = useState([1]);
	const [country, setCountry] = useState([]);
	const [optionsArea, setOptionsArea] = useState([]);
	const [optionsCountry, setOptionsCountry] = useState([]);
	const [filters, setFilters] = useState(null);
	const [userFilter, setUserFilter] = useState(false);

	const loadLists = useCallback(async () => {
		try {
			const { item } = await getCandidateInfo(id);
			const listArea = await getAreaList();
			const listCountry = await getCountry();

			setInterestAreas(await CandidatesApplyService.getCandidateInterestAreas(id));

			const cList = listCountry.map((item) => ({ value: item.id, label: item.name, color: "#666666" }));

			setOptionsArea(listArea.map((item) => ({ value: item.id, label: item.profileArea, color: "#666666" })));
			setOptionsCountry([{ value: "", label: "Country", color: "#666666" }, ...cList]);

			setCandidate(item);
			setAreas(listArea);
			setCountry(listCountry);
		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	}, []);

	const loadJobs = useCallback(async () => {
		const category = userFilter ? "" : "order";
		setListJobs([]);
		try {
			if (filters.therm && filters.therm !== "") {
				const { jobs, total_count } = await JobServices.getAllJobsByThermOrID(page, filters.therm, "");
				setTotalData(total_count);
				setListJobs(jobs);
				return null;
			}
			const areas = filters.areas.map((item) => item.value).toString();
			const { jobs, total_count } = await JobServices.getAllJobs(page, filters.country.value, areas, LIMIT, category);
			setTotalData(total_count);
			setListJobs(jobs);
		} catch (error) {
			console.error(error);
		} finally {
			setLoadingJobs(false);
		}
	}, [page, filters, userFilter]);

	const loadApplies = useCallback(async () => {
		try {
			const { id } = await JSON.parse(localStorage.getItem("user"));

			CandidatesApplyService.getOpportunitiesByCandidate(id).then((opportunities) => {
				setCandidateJobs(opportunities || []);
			});
		} catch (error) {
			console.error(error);
		} finally {
			return false;
		}
	}, []);

	useEffect(() => {
		if (candidate) {
			const [userCountry] = optionsCountry.filter((item) => candidate.country_id === item.value);

			setFilters({
				country: userCountry,
				areas: optionsArea.filter((item) => interestAreas.includes(item.value)),
			});
		}
	}, [optionsArea, optionsCountry, interestAreas, candidate]);

	useEffect(() => {
		setLoading(true);
		loadLists();
	}, [loadLists]);

	useEffect(() => {
		if (filters) {
			setLoadingJobs(true);
			loadJobs();
		}
	}, [loadJobs, filters]);

	useEffect(() => {
		loadApplies();
	}, [loadApplies]);

	const handleChangeArea = (event) => {
		setFilters({
			...filters,
			areas: event,
		});

		setUserFilter(true);
	};

	const handleChangeCountry = (event) => {
		setFilters({
			...filters,
			country: event,
		});

		setUserFilter(true);
	};

	const handleSearchThermOrID = async (event) => {
		setFilters({
			...filters,
			therm: event.currentTarget.value,
		});
	};

	return (
		<>
			{loading && <Loading />}
			{!loading && (
				<>
					<div className="row">
						<div className="col">
							<div className="row">
								<div className="col">
									<h1 className="my-4 bold">{jobsTranslate.relatedJobs}</h1>
									<p className="description-section">{jobsTranslate.relatedJobsDesc}</p>
								</div>
							</div>
							<div className="row my-4 mx-2">
								<div className="col-4">
									<div className="input-filters my-4">
										<SearchIcon color="#CCCCCC" size="18" />
										{filters && (
											<FormattedMessage id="searchInputJobsPH">
												{(msg) => (
													<input type="text" placeholder={msg} onChange={handleSearchThermOrID} className="searchTherm" value={filters.therm || ""} />
												)}
											</FormattedMessage>
										)}
										<span
											onClick={() => {
												setFilters({ ...filters, therm: "" });
											}}
											className="input-clear"
										>
											&times;
										</span>
									</div>
								</div>
								<div className="col">
									<div className="filters my-4">
										{filters && (
											<Select
												isDisabled={filters.therm !== "" && filters.therm}
												closeMenuOnSelect={false}
												components={animatedComponents}
												defaultValue={filters.areas}
												isMulti
												options={optionsArea}
												onChange={handleChangeArea}
												name="area"
											/>
										)}
									</div>
								</div>
								<div className="col-2">
									<div className="filters my-4">
										{filters && (
											<Select
												isDisabled={filters.therm !== "" && filters.therm}
												closeMenuOnSelect={false}
												components={animatedComponents}
												defaultValue={filters.country}
												options={optionsCountry}
												onChange={handleChangeCountry}
												name="country"
											/>
										)}
									</div>
								</div>
							</div>
							<div className="row mx-3">
								<div className="col">
									<hr />
									{userFilter && (
										<div className="d-flex small">
											{" "}
											{jobsTranslate.searchWithFilterText}
											<div className="vr mx-2" style={{ height: 20 }}></div>{" "}
											<p
												className="seeAll"
												onClick={() => {
													setUserFilter(false);
												}}
											>
												{jobsTranslate.showAllJobs}
											</p>
										</div>
									)}
								</div>
							</div>
							<div className="row mb-5">
								{loadingJobs && (
									<div className="col-12 d-flex justify-content-between loading-jobs">
										<Loading />
									</div>
								)}
								{!loadingJobs && (
									<div className="col-12 d-flex justify-content-between flex-wrap">
										<div className="row row-sm-cols-4 g-3 mb-5">
											{listJobs &&
												listJobs.map((item) => {
													const [areaFilter] = area?.filter((filter) => Number(filter.id) === Number(item.area_id));
													const [countryFilter] = country?.filter((filter) => Number(filter.id) === Number(item.country_id));
													return (
														<div key={item.id} className="flex-grow-1 col">
															<CardJob
																id={item.id}
																area={areaFilter?.profileArea}
																city={item.city}
																country={countryFilter?.name}
																date={item.date}
																title={item.title.length > 23 ? `${item.title.substring(0, 20)}...` : item.title}
																jobApply={!candidateJobs.includes(item.id)}
																loadApplies={loadApplies}
																nameCompany={item.name_company}
															/>
														</div>
													);
												})}
										</div>
									</div>
								)}
							</div>
							<div className="row my-5 mx-2">
								<div className="col ">
									<span className="amount-vacancies me-1">{totalData}</span>
									{jobsTranslate.jobsOportunityText}
								</div>
								<div className="col d-flex justify-content-end">
									<PaginationMydna limit={LIMIT} total={totalData} page={page} setPage={setPage} />
								</div>
							</div>
						</div>
					</div>
				</>
			)}
		</>
	);
};
export default Jobs;
